module.exports = __webpack_public_path__ + "img/banner.43837bc6.png";